import React from 'react';
import { t } from '@lingui/core/macro';

import {
  type SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import { Button } from '@rover/kibble/core';
import type { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { useRevampProfileContext } from '../../hooks/useRevampProfileContext';
import AdditionalRatesSection from '../ServiceSection/AdditionalRatesSection';

import { SitterProfileSeeAllRatesClicked } from './analyticsEvents';

const RevampAdditionalRates = ({
  services,
  serviceType,
  petType,
  petCount,
  isSitterInPetCareModesExperiment,
}: {
  services: EnhancedPersonSitterProfileService[];
  serviceType: string | undefined;
  petType: SearchParamsPetType;
  petCount: SearchParamsPetCounts;
  isSitterInPetCareModesExperiment: boolean;
}): JSX.Element => {
  const { showSittersRates } = useRevampProfileContext();

  return (
    <AdditionalRatesSection
      services={services}
      petType={petType}
      petCount={petCount}
      showSittersRates={showSittersRates}
      isSitterInPetCareModesExperiment={isSitterInPetCareModesExperiment}
      renderTrigger={(toggleModal) => (
        <Button
          variant="link"
          onPress={() => {
            emitAnalyticsEvent(
              new SitterProfileSeeAllRatesClicked({
                serviceSlug: serviceType ?? '',
                pageVariant: 'revamp',
              })
            );
            toggleModal();
          }}
          data-testid="revamp-see-all-rates"
          alignSelf="flex-start"
        >
          {t`See all rates`}
        </Button>
      )}
      isCtaModal
      isRevampVersion
    />
  );
};

export default RevampAdditionalRates;
